import { Injectable } from '@angular/core';
import { TranslationService } from '../translations';

@Injectable({ providedIn: 'root' })
export class DisplayService {
    constructor(private TR: TranslationService) {}

    // The id field is a type hack to get around "Weak Type Dectection"
    // colliding with SearchResults. Some details at
    // https://mariusschulz.com/articles/weak-type-detection-in-typescript
    display(
        item: {
            id?: string;
            firstName?: string;
            lastName?: string;
            email?: string;
            title?: string;
        },
        incomingOptions?: {
            lastFirst?: boolean;
            showEmail?: boolean;
            default?: string;
        }
    ) {
        const options = Object.assign(
            {
                lastFirst: false,
                showEmail: false,
                default: ''
            },
            incomingOptions
        );

        if (this.hasFullName(item)) {
            return this.fullName(item, options.lastFirst);
        }
        return (
            item.firstName ||
            item.lastName ||
            item.email ||
            item.title ||
            options.default ||
            ''
        );
    }

    // This code does very little but is required because TypeScript
    private hasFullName(person: {
        firstName?: string;
        lastName?: string;
    }): person is {
        firstName: string;
        lastName: string;
    } {
        return person.firstName && person.lastName ? true : false;
    }

    private fullName(
        person: {
            firstName: string;
            lastName: string;
        },
        lastNameFirst
    ): string {
        return lastNameFirst
            ? `${person.lastName}, ${person.firstName}`
            : `${person.firstName} ${person.lastName}`;
    }
}
